import { render, staticRenderFns } from "./ProfileStatisticView.vue?vue&type=template&id=c8f36f16&scoped=true&"
import script from "./ProfileStatisticView.vue?vue&type=script&lang=ts&"
export * from "./ProfileStatisticView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileStatisticView.vue?vue&type=style&index=0&id=c8f36f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f36f16",
  null
  
)

export default component.exports